import { FiChevronDown, FiExternalLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import {
  formatDeliveryAddress,
  formatOpsCurrency,
  formatOpsDate,
  formatOrderStatus,
  orderStatusTone,
  updatedByLabel,
} from "../ops-orders.utils";

export const OrderAccordion = ({ order }) => {
  const customerDirectory = String(order.user_type || "").toLowerCase().includes("guest") ? "guests" : "registered";

  return <details className="order-card">
    <summary>
      <div className="order-person">
        <div className="order-person-copy">
          <Link className="customer-email" to={`/admin/internal/customers/${customerDirectory}/${order.user_id}`} onClick={(event) => event.stopPropagation()}>{order.email || order.contact_name || order.user_id}</Link>
          <small>Order #{order.order_id.slice(-8).toUpperCase()}</small>
        </div>
      </div>
      <div className="campaign-stat order-summary-stat amount-stat"><span>Amount paid</span><strong>{formatOpsCurrency(order.total_amount_paid)}</strong></div>
      <div className="campaign-stat order-summary-stat slots-stat"><span>Slots</span><strong>{order.fractional_number_of_slots_purchased}</strong></div>
      <span className={`status-pill order-summary-status ${orderStatusTone(order.fulfillment_status)}`}>{formatOrderStatus(order.fulfillment_status)}</span>
      <FiChevronDown className="summary-chevron" aria-hidden="true" />
    </summary>
    <div className="order-body">
      <section className="order-details-panel">
        <div className="section-heading">
          <div><h3 className="section-title">Order details</h3><p>Delivery, payment and notes for this order.</p></div>
          <span className="order-date">Placed {formatOpsDate(order.created_at)}</span>
        </div>
        <div className="info-grid">
          <div className="info-item wide"><span>Delivery address</span><strong>{formatDeliveryAddress(order.delivery_location)}</strong></div>
          <div className="info-item"><span>Payment</span><strong>{formatOrderStatus(order.payment_status)} · {formatOpsCurrency(order.total_amount_paid)}</strong></div>
          <div className="info-item"><span>Membership</span><strong>{formatOrderStatus(order.membership_status)}</strong></div>
          <div className="info-item wide"><span>Customer order note</span><strong>{order.order_notes || "No note was provided."}</strong></div>
        </div>
      </section>
      <aside className="update-panel">
        <h3 className="section-title">Order activity</h3>
        <Link className="action-button transaction-link" to={`/admin/internal/operations/orders/${order.order_id}`}>View transaction <FiExternalLink /></Link>
        <div className="history"><h3 className="section-title">Fulfilment history</h3>{order.fulfillment_history?.length ? order.fulfillment_history.map((item, index) => {
          const updatedBy = updatedByLabel(item.updated_by);
          return <div className="history-item" key={`${item.status}-${item.updated_at}-${index}`}><span><strong>{formatOrderStatus(item.status)}</strong><small>{formatOpsDate(item.updated_at)}{updatedBy ? ` · Updated by ${updatedBy}` : ""}</small></span></div>;
        }) : <span className="empty-history">No fulfilment updates yet.</span>}</div>
      </aside>
    </div>
  </details>;
};
